import { render, staticRenderFns } from "./LoginContainer.vue?vue&type=template&id=0b31c8a4&scoped=true"
import script from "./LoginContainer.vue?vue&type=script&lang=ts"
export * from "./LoginContainer.vue?vue&type=script&lang=ts"
import style0 from "./LoginContainer.vue?vue&type=style&index=0&id=0b31c8a4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b31c8a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b31c8a4')) {
      api.createRecord('0b31c8a4', component.options)
    } else {
      api.reload('0b31c8a4', component.options)
    }
    module.hot.accept("./LoginContainer.vue?vue&type=template&id=0b31c8a4&scoped=true", function () {
      api.rerender('0b31c8a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/login/LoginContainer.vue"
export default component.exports